import { FaExternalLinkAlt, FaChevronRight } from "react-icons/fa";
import LateralMenuButtonSubCategory from "./LateralMenuButtonSubCategory";

const LateralMenuButton = ({ title, item, isExpanded, onToggle }) => {

  const hasItems = !item.directAccessLink && item.items?.length > 0;

  const handleButtonClick = () => {
    if (item.directAccessLink) {
      window.open(item.directAccessLink, "_blank", "noopener,noreferrer");
    } else {
      onToggle();
    }
  };

  return (
    <div className="flex flex-col">
      {/* Botón principal */}
      <button
        className={`w-full flex items-center justify-between px-4 py-3 rounded-xl text-sm font-semibold transition-all duration-200 
          ${isExpanded 
            ? `bg-${item.color}-600 text-white shadow-lg shadow-${item.color}-200` 
            : `bg-white text-gray-700 hover:bg-${item.color}-50 border border-gray-200 hover:border-${item.color}-300`
          }`}
        onClick={handleButtonClick}
      >
        <div className="flex items-center gap-2">
          <div className={`w-2.5 h-2.5 rounded-full ${isExpanded ? 'bg-white' : `bg-${item.color}-500`}`} />
          <span className="truncate">{title}</span>
        </div>
        {item.directAccessLink ? (
          <FaExternalLinkAlt className="text-[10px] shrink-0 opacity-60" />
        ) : hasItems ? (
          <FaChevronRight className={`text-[10px] shrink-0 transition-transform duration-200 ${isExpanded ? 'rotate-90' : ''}`} />
        ) : null}
      </button>

      {/* Sub-items expandibles */}
      {isExpanded && hasItems && (
        <div className="mt-1 ml-2 flex flex-col gap-0.5 py-1 max-h-[40vh] overflow-y-auto">
          {item.items.map((subItem, i) => (
            !subItem.itemLink && subItem.subCategoryLinks && subItem.subCategoryLinks.length > 0 ? (
              <LateralMenuButtonSubCategory key={i} item={subItem} />
            ) : (
              <a
                key={i}
                href={subItem.itemLink}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-3 py-2.5 text-xs text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-150"
              >
                <FaExternalLinkAlt className="text-[9px] shrink-0" />
                <span className="truncate">{subItem.itemName}</span>
              </a>
            )
          ))}
        </div>
      )}
    </div>
  );
}

export default LateralMenuButton
